/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Box,
  CircularProgress,
  Tooltip,
  Card,
  CardContent
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import PaymentIcon from "@material-ui/icons/Payment";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import PrintIcon from "@material-ui/icons/Print";
import RefreshIcon from "@material-ui/icons/Refresh";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import PersonIcon from "@material-ui/icons/Person";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import moment from "moment";
import "moment/locale/th";
import { FinanceBudgetService } from "_services/financebudget.service";

moment.locale("th");

const useStyles = makeStyles(theme => ({
  filterCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
  },
  tableContainer: {
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
  },
  tableHeadCell: {
    backgroundColor: "#1e3a8a",
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "13px",
    padding: "10px 12px"
  },
  tableRow: {
    "&:nth-of-type(even)": {
      backgroundColor: "#f8fafc"
    },
    "&:hover": {
      backgroundColor: "#f1f5f9"
    }
  },
  statusChip: {
    fontWeight: "bold",
    fontSize: "12px"
  },
  paginationBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2)
  }
}));

const getCurrentFiscalYear = () => {
  const now = moment();
  return (now.month() >= 9 ? now.year() + 543 + 1 : now.year() + 543).toString();
};

export default function ProtectMoneyList({
  onAddNew,
  onEdit,
  onManagePayment,
  onPrint
}) {
  const classes = useStyles();

  const currentUser = (() => {
    try {
      const u = localStorage.getItem("currentUser");
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  })();

  const isFinanceAccount = (() => {
    if (!currentUser) return false;
    const userDepts = Array.isArray(currentUser.userDepartment)
      ? currentUser.userDepartment
      : Array.isArray(currentUser.userView?.userDepartment)
      ? currentUser.userView.userDepartment
      : [];

    const isBudgetDep = userDepts.some(u => {
      const depKey = Number(u.departmentKey);
      return depKey === 102 || depKey === 135 || depKey === 157;
    });

    const isAdmin =
      currentUser?.roles?.includes("Admin") ||
      currentUser?.userName === "madarakung" ||
      userDepts.some(u => Number(u.departmentKey) === 108);

    return isBudgetDep || isAdmin;
  })();
  const isFinanceUser = isFinanceAccount;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    items: [],
    totalCount: 0,
    pageNumber: 1,
    pageSize: 25,
    totalPages: 0
  });

  // Filters
  const [search, setSearch] = useState("");
  const [year, setYear] = useState(() => getCurrentFiscalYear());
  const [payAllStatus, setPayAllStatus] = useState("all");
  const [protectDep, setProtectDep] = useState("");
  const [years, setYears] = useState([]);
  const [protectDeps, setProtectDeps] = useState([]);

  useEffect(() => {
    loadLookups();
  }, []);

  useEffect(() => {
    fetchList(1);
  }, [year, payAllStatus, protectDep]);

  const loadLookups = async () => {
    try {
      const [yRes, depRes] = await Promise.all([
        FinanceBudgetService.getYears(),
        FinanceBudgetService.getProtectDeps()
      ]);
      if (yRes.data.success && yRes.data.data.length > 0) {
        setYears(yRes.data.data);
        const fiscalYear = getCurrentFiscalYear();
        const exists = yRes.data.data.some(y => y.value === fiscalYear);
        if (exists) {
          setYear(fiscalYear);
        } else {
          setYear(yRes.data.data[0].value);
        }
      }
      if (depRes.data?.success) setProtectDeps(depRes.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchList = async (page = 1) => {
    setLoading(true);
    try {
      const params = {
        search: search.trim() || undefined,
        year: year || undefined,
        payAllStatus: payAllStatus !== "all" ? payAllStatus : undefined,
        protectDep: protectDep ? parseInt(protectDep) : undefined,
        pageNumber: page,
        pageSize: 25
      };
      const res = await FinanceBudgetService.getProtectList(params);
      if (res.data.success) {
        setData(res.data.data);
      }
    } catch (err) {
      console.error("Fetch protect list error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchSubmit = e => {
    e.preventDefault();
    fetchList(1);
  };

  const handleDelete = async (id, number) => {
    if (
      !window.confirm(
        `ยืนยันการลบใบกันเงินเลขที่ ${number}?\nระบบจะคืนเงินที่กันไว้กลับโครงการโดยอัตโนมัติ`
      )
    ) {
      return;
    }
    try {
      const res = await FinanceBudgetService.deleteProtect(id);
      if (res.data.success) {
        alert("ลบใบกันเงินเรียบร้อยแล้ว");
        fetchList(data.pageNumber);
      }
    } catch (err) {
      alert(
        "เกิดข้อผิดพลาดในการลบ: " + (err.response?.data?.message || err.message)
      );
    }
  };

  const getStatusChip = item => {
    const isChecked = Boolean(item.checkerDT || item.checkerCode);
    let payChip;
    if (item.payAll === "1") {
      payChip = (
        <Chip
          label="เบิกจ่ายครบแล้ว"
          size="small"
          style={{ backgroundColor: "#dcfce7", color: "#166534" }}
          className={classes.statusChip}
        />
      );
    } else if (item.totalPaid > 0) {
      payChip = (
        <Chip
          label="เบิกจ่ายบางส่วน"
          size="small"
          style={{ backgroundColor: "#e0f2fe", color: "#0369a1" }}
          className={classes.statusChip}
        />
      );
    } else {
      payChip = (
        <Chip
          label="รอเบิกจ่าย"
          size="small"
          style={{ backgroundColor: "#fef3c7", color: "#92400e" }}
          className={classes.statusChip}
        />
      );
    }

    if (isChecked) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            alignItems: "center"
          }}
        >
          {payChip}
          <Tooltip
            title={`ตรวจสอบโดย: ${item.checkerName || item.checkerCode || "-"}`}
          >
            <Chip
              size="small"
              label="ตรวจสอบแล้ว"
              style={{
                backgroundColor: "#ecfdf5",
                color: "#059669",
                border: "1px solid #a7f3d0",
                fontSize: "10px",
                height: 18,
                cursor: "default"
              }}
            />
          </Tooltip>
        </div>
      );
    }

    return payChip;
  };

  return (
    <div>
      {/* Filters & Actions Bar */}
      <Card className={classes.filterCard}>
        <form onSubmit={handleSearchSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                label="ปีงบประมาณ"
                fullWidth
                size="small"
                variant="outlined"
                value={year}
                onChange={e => setYear(e.target.value)}
              >
                <MenuItem value="">-- ทุกปีงบประมาณ --</MenuItem>
                {years.map(y => (
                  <MenuItem key={y.value} value={y.value}>
                    {y.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                label="สถานะการเบิกจ่าย"
                fullWidth
                size="small"
                variant="outlined"
                value={payAllStatus}
                onChange={e => setPayAllStatus(e.target.value)}
              >
                <MenuItem value="all">ทั้งหมด</MenuItem>
                <MenuItem value="pending">รอเบิกจ่าย</MenuItem>
                <MenuItem value="completed">เบิกจ่ายครบแล้ว (ปิดงาน)</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                label="หน่วยงานที่ขอ"
                fullWidth
                size="small"
                variant="outlined"
                value={protectDep}
                onChange={e => setProtectDep(e.target.value)}
              >
                <MenuItem value="">-- ทุกหน่วยงาน --</MenuItem>
                {protectDeps.map(d => (
                  <MenuItem key={d.value} value={d.value}>
                    {d.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="ค้นหาเลขที่ / บันทึก"
                fullWidth
                size="small"
                variant="outlined"
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="พิมพ์เลขที่เพื่อค้นหา..."
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<SearchIcon />}
                  style={{ marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button
                  variant="outlined"
                  color="default"
                  startIcon={<RefreshIcon />}
                  onClick={() => {
                    setSearch("");
                    fetchList(1);
                  }}
                >
                  รีเซ็ต
                </Button>
              </div>

              {onAddNew && (
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<AddIcon />}
                  onClick={onAddNew}
                  style={{ backgroundColor: "#059669", color: "#fff" }}
                >
                  + บันทึกใบกันเงินใหม่
                </Button>
              )}
            </Grid>
          </Grid>
        </form>
      </Card>

      {/* Protect List Table */}
      <Paper className={classes.tableContainer}>
        {loading ? (
          <Box p={4} textAlign="center">
            <CircularProgress />
            <Typography style={{ marginTop: 16 }}>
              กำลังโหลดรายการใบกันเงิน...
            </Typography>
          </Box>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableHeadCell}
                  align="center"
                  style={{ width: "10%" }}
                >
                  เลขที่ใบกันเงิน
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  align="center"
                  style={{ width: "9%" }}
                >
                  ลงวันที่
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  style={{ width: "12%" }}
                >
                  ตามบันทึก
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  style={{ width: "22%" }}
                >
                  โครงการ / กิจกรรม
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  style={{ width: "14%" }}
                >
                  บริษัท / ผู้ขาย
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  align="right"
                  style={{ width: "9%" }}
                >
                  ยอดกันเงิน
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  align="right"
                  style={{ width: "9%" }}
                >
                  เบิกจ่ายแล้ว
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  align="center"
                  style={{ width: "9%" }}
                >
                  สถานะ
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  align="center"
                  style={{ width: "6%" }}
                >
                  จัดการ
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.items && data.items.length > 0 ? (
                data.items.map(item => (
                  <TableRow key={item.id} className={classes.tableRow}>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "#1e3a8a" }}
                    >
                      {item.number}
                    </TableCell>
                    <TableCell align="center">
                      {item.kDate
                        ? moment(item.kDate)
                            .add(543, "years")
                            .format("DD/MM/YYYY")
                        : "-"}
                    </TableCell>
                    <TableCell>
                      {item.noteName || item.note || "-"}
                      {item.protectDepName && (
                        <div style={{ fontSize: "11px", color: "#64748b" }}>
                          ({item.protectDepName})
                        </div>
                      )}
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        style={{ fontWeight: "500", fontSize: "13px" }}
                      >
                        {item.projectName || "-"}
                      </Typography>
                      {item.categoryName && (
                        <span style={{ fontSize: "11px", color: "#0284c7" }}>
                          หมวด: {item.categoryName}
                        </span>
                      )}
                    </TableCell>
                    <TableCell style={{ fontSize: "12px" }}>
                      {item.companyName || "-"}
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{ fontWeight: "bold", color: "#0369a1" }}
                    >
                      {item.money.toLocaleString("th-TH", {
                        minimumFractionDigits: 2
                      })}
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{ fontWeight: "bold", color: "#16a34a" }}
                    >
                      {item.totalPaid.toLocaleString("th-TH", {
                        minimumFractionDigits: 2
                      })}
                    </TableCell>
                    <TableCell align="center">{getStatusChip(item)}</TableCell>
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      >
               {/* Action ปุ่มแก้ไข / ตรวจสอบ / ดูข้อมูล */}
                        {isFinanceUser ? (
                          <Tooltip
                            title={
                              Boolean(item.checkerDT || item.checkerCode)
                                ? "ตรวจสอบแล้ว (คลิกเพื่อแก้ไข/ตรวจสอบเพิ่มเติม)"
                                : "ตรวจสอบใบกันเงิน"
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={() => onEdit(item.id)}
                              style={{
                                color: Boolean(
                                  item.checkerDT || item.checkerCode
                                )
                                  ? "#10b981"
                                  : "#6366f1"
                              }}
                            >
                              <VerifiedUserIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        ) : Boolean(item.checkerDT || item.checkerCode) ? (
                          <Tooltip title="ดูข้อมูลใบกันเงิน (ผ่านการตรวจสอบแล้ว ไม่อนุญาตให้แก้ไข)">
                            <IconButton
                              size="small"
                              onClick={() => onEdit(item.id)}
                              style={{ color: "#0284c7" }}
                            >
                              <PersonIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="แก้ไข">
                            <IconButton
                              size="small"
                              onClick={() => onEdit(item.id)}
                              style={{ color: "#f59e0b" }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}

                        <Tooltip title="พิมพ์ใบกันเงิน">
                          <IconButton
                            size="small"
                            onClick={() => onPrint(item.id)}
                            style={{ color: "#4b5563" }}
                          >
                            <PrintIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        
                        <Tooltip title="บันทึกเบิกจ่ายเงิน">
                          <IconButton
                            size="small"
                            onClick={() =>
                              onManagePayment(item.id, item.number)
                            }
                            style={{ color: "#0284c7" }}
                          >
                            <PaymentIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        {/* ปุ่มลบใบกันเงิน: ซ่อนหากเจ้าหน้าที่ทั่วไปและผ่านการตรวจสอบแล้ว */}
                        {(!Boolean(item.checkerDT || item.checkerCode) ||
                          isFinanceUser) && (
                          <Tooltip title="ลบใบกันเงิน">
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(item.id, item.number)}
                              style={{ color: "#ef4444" }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={9}
                    align="center"
                    style={{ padding: "40px", color: "#94a3b8" }}
                  >
                    ไม่พบรายการใบกันเงินตามเงื่อนไขที่เลือก
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}

        {/* Pagination Bar */}
        <div className={classes.paginationBox}>
          <Typography variant="body2" color="textSecondary">
            แสดงทั้งหมด <b>{data.totalCount}</b> รายการ (หน้า {data.pageNumber}{" "}
            จาก {data.totalPages || 1})
          </Typography>
          <div>
            <Button
              size="small"
              startIcon={<NavigateBeforeIcon />}
              disabled={data.pageNumber <= 1 || loading}
              onClick={() => fetchList(data.pageNumber - 1)}
            >
              ก่อนหน้า
            </Button>
            <Button
              size="small"
              endIcon={<NavigateNextIcon />}
              disabled={data.pageNumber >= data.totalPages || loading}
              onClick={() => fetchList(data.pageNumber + 1)}
            >
              ถัดไป
            </Button>
          </div>
        </div>
      </Paper>
    </div>
  );
}
